var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('t-form-item',{attrs:{"label":_vm.schema.text,"prop":_vm.schema.propertyName,"required":_vm.schema.required,"important":_vm.schema.important}},[_c('v-md-editor',{attrs:{"value":_vm.value || '',"height":"400px","mode":"edit","left-toolbar":"undo redo | h bold italic | ul ol | hr link","codemirror-config":{
    lineNumbers: false,
    styleActiveLine: false,
    dragDrop: true,
    events: ['drop', 'dragenter'],
  }},on:{"input":v => _vm.$emit('input', v)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }